import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Navbar({ scrolled, customSubtitle, logoHref }: { scrolled: boolean; customSubtitle?: string; logoHref?: string }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [japaneseDropdownOpen, setJapaneseDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const japaneseSubLinks = [
    { label: 'Event', href: '/event' },
    { label: 'Personal', href: '/personal' },
    { label: 'Biz', href: '/biz' },
  ];

  const handleNav = (href: string) => {
    setMobileMenuOpen(false);
    setJapaneseDropdownOpen(false);
    navigate(href);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || mobileMenuOpen ? 'bg-[#0A0A0A]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
      style={{ overflow: 'visible' }}
    >
      <div style={{ width: '100%', paddingLeft: '24px', paddingRight: '24px', paddingTop: '12px', paddingBottom: '12px' }}>
        <div className="flex items-center justify-between">
          {/* 로고 */}
          <button
            onClick={() => handleNav(logoHref ?? '/')}
            className="flex items-center gap-2 cursor-pointer bg-transparent border-none p-0"
            style={{ flexShrink: 0, minWidth: 'fit-content' }}
          >
            <div className="flex flex-col leading-none">
              <span className="text-xl md:text-2xl font-bold text-white" style={{ whiteSpace: 'nowrap' }}>LEXO</span>
              <span className="text-gray-400 tracking-wide" style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>
                {customSubtitle ?? '강한 일본어'}
              </span>
            </div>
          </button>

          {/* 데스크탑 메뉴 */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => handleNav('/english')}
              className="text-gray-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer text-base bg-transparent border-none"
            >
              강한 영어
            </button>

            <div
              className="relative"
              onMouseEnter={() => setJapaneseDropdownOpen(true)}
              onMouseLeave={() => setJapaneseDropdownOpen(false)}
            >
              <button
                onClick={() => handleNav('/')}
                className="flex items-center gap-1 text-gray-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer text-base bg-transparent border-none"
              >
                강한 일본어
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${japaneseDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {japaneseDropdownOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-36 bg-[#1A1A1A] border border-gray-700 rounded-xl shadow-xl overflow-hidden">
                  {japaneseSubLinks.map((link) => (
                    <button
                      key={link.href}
                      onClick={() => handleNav(link.href)}
                      className="block w-full text-left px-4 py-3 text-sm text-gray-300 hover:text-white hover:bg-white/10 transition-colors whitespace-nowrap bg-transparent border-none cursor-pointer"
                    >
                      {link.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* 모바일 햄버거 버튼 */}
          <button
            className="md:hidden flex items-center justify-center w-9 h-9 text-white cursor-pointer"
            onClick={() => setMobileMenuOpen((prev) => !prev)}
            aria-label="메뉴 열기"
          >
            {mobileMenuOpen ? (
              <i className="ri-close-line text-2xl"></i>
            ) : (
              <i className="ri-menu-line text-2xl"></i>
            )}
          </button>
        </div>
      </div>

      {/* 모바일 드롭다운 메뉴 */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-[#0A0A0A]/98 backdrop-blur-md border-t border-white/10">
          <div className="flex flex-col px-4 py-3 space-y-1">
            <button
              onClick={() => handleNav('/english')}
              className="text-left text-gray-300 hover:text-white hover:bg-white/5 transition-colors whitespace-nowrap cursor-pointer text-base px-3 py-3 rounded-lg bg-transparent border-none"
            >
              강한 영어
            </button>

            <button
              onClick={() => handleNav('/')}
              className="text-left text-gray-300 hover:text-white hover:bg-white/5 transition-colors whitespace-nowrap cursor-pointer text-base px-3 py-3 rounded-lg bg-transparent border-none"
            >
              강한 일본어
            </button>

            {japaneseSubLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => handleNav(link.href)}
                className="text-left text-gray-400 hover:text-white hover:bg-white/5 transition-colors whitespace-nowrap cursor-pointer text-sm px-6 py-2.5 rounded-lg bg-transparent border-none"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
